
import Vue from 'vue';

export default {
	namespaced : true,
	state: {
		schoolFooterEnabled : null,
		activeFooterStatus: "logged-in",
		schoolFooterData : {},
		pageFooterData : {},
		hasSingleFooterStatus: true
	},
	actions : {
		setSchoolFooterData ( {commit} , payload) {
			commit('setSchoolFooterData',payload);
		},
		setPageFooterData ( {commit} , payload) {
			commit('setPageFooterData',payload);
		},
		setHasSingleFooterStatus( {commit , state,dispatch}, payload){
			commit('setHasSingleFooterStatus', payload);
			if (payload) {
				dispatch('setActiveFooterStatus', 'logged-in');
			}
		},
		setFooterStatusData( {commit}, payload){
			commit('setFooterStatusData', payload);
		},
		setSchoolFooterEnabled ( {commit , state, rootState,dispatch} , payload) {

			if (!payload && !state.pageFooterData){
				dispatch("mergeSchoolToPageFooter");
			}

			commit('setSchoolFooterEnabled',payload);
		},
		setActiveFooterStatus ( {commit}, payload) {
			commit('setActiveFooterStatus',payload);
		},
		mergeSchoolToPageFooter ({commit , rootState , state},) {
			for (let footerStatus in state.schoolFooterData) {
				if (!state.schoolFooterData.hasOwnProperty(footerStatus)) {
					continue;
				}

				let footerId = state.schoolFooterData[footerStatus].sectionId;
				let footerState = rootState.sections.sectionStates[footerId];
				let newId = footerState.createSectionId();
				let clonedData = copyJson(footerState.myData);

				clonedData = footerState.changeStateStylesId(clonedData,newId);
				clonedData.sectionId = newId;
				clonedData.content = footerState.myNode.outerHTML.replace(footerId,newId);

				if (!state.pageFooterData) {
					state.pageFooterData = {};

				}

				commit('mergeSchoolToPageFooter' , {footerStatus , clonedData});

			}
		},
		setSchoolFooterElementData ({commit,rootState} , payload){
			let elementState = rootState.elements.elementStates[payload.elementId];
			commit('setSchoolFooterElementData', {payload, elementState});
		},
		setPageFooterElementData ({commit,rootState} , payload){
			let elementState = rootState.elements.elementStates[payload.elementId];
			commit('setPageFooterElementData', {payload, elementState});
		},
		setSchoolFooterComponentData ({commit,rootState} , payload){
			let componentState = rootState.components.componentStates[payload.componentId];
			commit('setSchoolFooterComponentData', {payload, componentState});
		},
		setPageFooterComponentData ({commit,rootState} , payload){
			let componentState = rootState.components.componentStates[payload.componentId];
			commit('setPageFooterComponentData', {payload, componentState});
		},
		removeSchoolFooterElement ({commit} , payload){
			commit('removeSchoolFooterElement', payload);
		},
		removePageFooterElement ({commit} , payload){
			commit('removePageFooterElement', payload);
		},
		removeSchoolFooterComponent ({commit} , payload){
			commit('removeSchoolFooterComponent', payload);
		},
		removePageFooterComponent ({commit} , payload){
			commit('removePageFooterComponent', payload);
		},
	},
	mutations : {
		mergeSchoolToPageFooter (state,data) {
			Vue.set(state.pageFooterData, data.footerStatus , data.clonedData);
		},
		setHasSingleFooterStatus (state,flag) {
			state.hasSingleFooterStatus = flag;
		},
		setActiveFooterStatus (state,footerStatus) {
			state.activeFooterStatus = footerStatus;
		},
		setSchoolFooterEnabled ( state , flag ) {
			state.schoolFooterEnabled = flag;
		},
		setSchoolFooterData ( state , data) {
			state.schoolFooterData = copyJson(data);
			//state.schoolFooterData = CommonFooterData;
		},
		setPageFooterData ( state , data) {
			state.pageFooterData = data;
		},		
		setFooterStatusData( state, payload){
			let status = payload.status;
			let type = (payload.type.toLowerCase() == 'schoolfooter')? 'schoolFooterData' : 'pageFooterData' ;
			Vue.set(state[type], status, {...state[type][status], ...payload.data});
		},
		removeSchoolFooterComponent (state , componentId) {
			for (let footerStatus in state.schoolFooterData) {

				if (!state.schoolFooterData.hasOwnProperty(footerStatus)) {
					continue;
				}

				if (state.schoolFooterData[footerStatus].components && state.schoolFooterData[footerStatus].components[componentId]) {
					Vue.delete(state.schoolFooterData[footerStatus].components, componentId);
				}
			}
		},
		removePageFooterComponent (state , componentId) {
			for (let footerStatus in state.pageFooterData) {

				if (!state.pageFooterData.hasOwnProperty(footerStatus)) {
					continue;
				}

				if (state.pageFooterData[footerStatus].components && state.pageFooterData[footerStatus].components[componentId]) {
					Vue.delete(state.pageFooterData[footerStatus].components, componentId);
				}
			}
		},
		removeSchoolFooterElement (state , elementId) {
			for (let footerStatus in state.schoolFooterData) {

				if (!state.schoolFooterData.hasOwnProperty(footerStatus)) {
					continue;
				}

				if (state.schoolFooterData[footerStatus].elements && state.schoolFooterData[footerStatus].elements[elementId]) {
					Vue.delete(state.schoolFooterData[footerStatus].elements, elementId);
				}
			}
		},
		removePageFooterElement (state , elementId) {
			for (let footerStatus in state.pageFooterData) {

				if (!state.pageFooterData.hasOwnProperty(footerStatus)) {
					continue;
				}

				if (state.pageFooterData[footerStatus].elements && state.pageFooterData[footerStatus].elements[elementId]) {
					Vue.delete(state.pageFooterData[footerStatus].elements, elementId);
				}
			}
		},
		setPageFooterComponentData (state , componentData) {
			let data = componentData.payload;
			let componentState = componentData.componentState;
			let footerStatus = componentState.footerStatus;

			// console.log("setPageTopbarComponentData: " , data,componentState)
			if (data && componentState) {

				if (state.pageFooterData === null) {
					Vue.set(state,"pageFooterData" , {});
				}

				if (typeof state.pageFooterData[footerStatus] === "undefined") {
					Vue.set(state.pageFooterData, footerStatus, {});
				}

				if (typeof state.pageFooterData[footerStatus].components === "undefined") {
					Vue.set(state.pageFooterData[footerStatus], "components" , {});
				}

				if (typeof state.pageFooterData[footerStatus].components[data.componentId] === "undefined") {
					Vue.set(state.pageFooterData[footerStatus].components, data.componentId , {});
				}


				for (let key in data) {

					if (!data.hasOwnProperty(key)
					// || key === "componentId"
					) {
						continue;
					}

					Vue.set(state.pageFooterData[footerStatus].components[data.componentId], key, data[key]);
				}
			}
		},
		setSchoolFooterComponentData(state , componentData) {
			let data = componentData.payload;
			let componentState = componentData.componentState;
			let footerStatus = componentState.footerStatus;

			// console.log("setSchoolTopbarComponentData: " , data,componentState)
			if (data && componentState) {

				if (state.schoolFooterData === null) {
					Vue.set(state,"schoolFooterData" , {});
				}

				if (typeof state.schoolFooterData[footerStatus] === "undefined") {
					Vue.set(state.schoolFooterData, footerStatus, {});
				}

				if (typeof state.schoolFooterData[footerStatus].components === "undefined") {
					Vue.set(state.schoolFooterData[footerStatus], "components" , {});
				}

				if (typeof state.schoolFooterData[footerStatus].components[data.componentId] === "undefined") {
					Vue.set(state.schoolFooterData[footerStatus].components, data.componentId , {});
				}

				for (let key in data) {

					if (!data.hasOwnProperty(key)
					// || key === "componentId"
					) {
						continue;
					}

					Vue.set(state.schoolFooterData[footerStatus].components[data.componentId], key, data[key]);
				}
			}

		},
		setPageFooterElementData(state , elementData) {
			let data = elementData.payload;
			let elementState = elementData.elementState;
			let footerStatus = elementState.footerStatus;

			if (data && elementState) {

				if (state.pageFooterData === null) {
					Vue.set(state,"pageFooterData" , {});
				}

				if (typeof state.pageFooterData[footerStatus] === "undefined") {
					Vue.set(state.pageFooterData, footerStatus, {});
				}

				if (typeof state.pageFooterData[footerStatus].elements === "undefined") {
					Vue.set(state.pageFooterData[footerStatus], "elements" , {});
				}

				if (typeof state.pageFooterData[footerStatus].elements[data.elementId] === "undefined") {
					Vue.set(state.pageFooterData[footerStatus].elements, data.elementId , {});
				}

				for (let key in data) {

					if (!data.hasOwnProperty(key)
					// || key === "elementId"
					) {
						continue;
					}

					Vue.set(state.pageFooterData[footerStatus].elements[data.elementId], key, data[key]);
				}
			}
		},
		setSchoolFooterElementData(state , elementData) {
			let data = elementData.payload;
			let elementState = elementData.elementState;
			let footerStatus = elementState.footerStatus;

			// console.log("setSchoolTopbarElementData: " , data,elementState);

			if (data && elementState) {

				if (state.schoolFooterData === null) {
					Vue.set(state,"schoolFooterData" , {});
				}

				if (typeof state.schoolFooterData[footerStatus] === "undefined") {
					Vue.set(state.schoolFooterData, footerStatus, {});
				}

				if (typeof state.schoolFooterData[footerStatus].elements === "undefined") {
					Vue.set(state.schoolFooterData[footerStatus], "elements" , {});
				}

				if (typeof state.schoolFooterData[footerStatus].elements[data.elementId] === "undefined") {
					Vue.set(state.schoolFooterData[footerStatus].elements, data.elementId , {});
				}

				for (let key in data) {

					if (!data.hasOwnProperty(key)
					// || key === "elementId"
					) {
						continue;
					}

					Vue.set(state.schoolFooterData[footerStatus].elements[data.elementId], key, data[key]);
				}
			}
		},
	},

}